import React, { useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import apiClient from "../../../api/apiClient";
import { publish } from '../../../utils/pubsubWrapper';
import { Form, Button, Row, Col, Alert, ProgressBar, Spinner } from "react-bootstrap";
import Input from "../../shared/Input";
import AlertMassage from '../../shared/Alert';
import { BackArrowIcon } from '../../../utils/FontIcon';
import { UPLOADDOCUMENTS } from '../../../utils/ApiEndPoint';

export default function AddResource() {
    const navigate = useNavigate();
    const resourceInputRef = useRef(null);
    const [form, setForm] = useState({
        title: "",
        tags: "",
        description: "",
        document: '',
    });
    const [resourceMetadata, setResourceMetadata] = useState({});
    const [progress, setProgress] = useState(0);
    const [errors, setErrors] = useState({});
    const [showAlert, setShowAlert] = useState({
        type: '',
        title: '',
        msg: ``,
        show: false
    });
    const [waitForResponse, setWaitForResponse] = useState(false);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: files ? files[0] : value,
        }));

        if (files) {
            const file = files[0];
            console.log('file.type:::', file.type)
            const basicMeta = {
                name: file.name,
                size: (file.size / 1024 / 1024).toFixed(2),
                type: file.type,
                lastModified: new Date(file.lastModified).toLocaleString(),
            };
            setResourceMetadata(basicMeta);
        }
        setErrors((prev) => ({ ...prev, [name]: undefined }));
    };
    const validate = () => {
        const newErrors = {};
        if (!form.title.trim()) newErrors.title = "Title is required";
        if (!form.tags.trim()) newErrors.tags = "Keywords are required";
        if (!form.description.trim()) newErrors.description = "Description is required";
        if (!form.document) newErrors.document = "Refrence document is required";
        else if (form.document && resourceMetadata.size > 50) newErrors.document = "Iamge Size must be less then 50 mb";
        return newErrors;
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setWaitForResponse(true);
        savedata();
    };
    const savedata = async () => {
        const data = new FormData();
        Object.keys(form).forEach(key => data.append(key, form[key]));
        data.append('mediaMetadata', resourceMetadata);

        let tempAlert = {
            type: 'danger',
            title: 'Error',
            msg: '',
            show: true
        }
        apiClient.post(UPLOADDOCUMENTS, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setProgress(percent);
            }
        }).then((response) => {
            if (response.status === 201) {
                tempAlert.type = 'success';
                tempAlert.title = 'Success';
                tempAlert.msg = `✅ Refrence document uploaded successfully!`;
                setShowAlert(tempAlert)
                setForm({
                    title: "",
                    tags: "",
                    description: "",
                    document: ''
                });
                setResourceMetadata({});
                setErrors({});
                if (resourceInputRef.current) {
                    resourceInputRef.current.value = '';
                }
                publish('FETCH_RESOURCE');
            } else {
                tempAlert.msg = `❌ Upload failed. error:${response.error}`;
                setShowAlert(tempAlert);
            }
        }).catch((error) => {
            tempAlert.msg = '❌ Upload failed.';
            setShowAlert(tempAlert);
        }).finally(() => {
            setWaitForResponse(false);
            setProgress(0);
        });
    }
    const handelGotoCourse = (e) => {
        navigate('/createcourse');
    }
    const resetForm = (e) => {
        setForm({
            title: "",
            tags: "",
            description: "",
            document: ''
        });
        setResourceMetadata({});
        setErrors({});
        if (resourceInputRef.current) {
            resourceInputRef.current.value = '';
        }
    }
    const hideAlert = () => {
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        })
    }
    return (
        <div className="add-video-bg" >
            <Row>
                <Col md={10}>
                    <h4 className="mb-0 fw-bold">Add Course Materials</h4>
                    <div className="mb-2 ms-1 small fw-semibold text-secondary">(Manage Resource/Reference)</div>
                </Col>

                <Col md={2} className="text-end">
                    <Button variant="outline-dark" onClick={handelGotoCourse} title="Go to course"><BackArrowIcon />Go to course</Button>
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <div className="add-video-container">
                        {(progress > 0 && progress < 100) && (
                            <Row>
                                <Alert variant="light" className="mt-3">
                                    <ProgressBar striped animated variant="success" now={progress} label={`${progress}%`} />
                                </Alert>
                            </Row>
                        )}
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col md={7} className="pe-md-5" style={{ borderRight: "1px solid #dee2e6" }}>
                                    <Row>
                                        <Col lg={12} className="pb-2">
                                            <div className="mb-3 fw-semibold fs-8 onerem">Create your own Material library now.</div>
                                        </Col>
                                        <Col md={6}>
                                            <Input
                                                label="Title"
                                                isMandetory={true}
                                                name="title"
                                                value={form.title}
                                                onChange={handleChange}
                                                placeholder="enter material title"
                                                isInvalid={!!errors.title}
                                                feedback={errors.title}
                                                inlineFeedback={true}
                                                maxLength={80}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <Input
                                                label="Keywords"
                                                isMandetory={true}
                                                name="tags"
                                                value={form.tags}
                                                onChange={handleChange}
                                                placeholder="enter Keywords (e.g.education, farmer, insurence etc)"
                                                isInvalid={!!errors.tags}
                                                feedback={errors.tags}
                                                inlineFeedback={true}
                                            />
                                        </Col>
                                        <Col md={12}>
                                            <Input
                                                label="Description"
                                                isMandetory={true}
                                                name="description"
                                                value={form.description}
                                                onChange={handleChange}
                                                placeholder="Describe the material or its purpose"
                                                isInvalid={!!errors.description}
                                                feedback={errors.description}
                                                as="textarea"
                                                rows={2}
                                                inlineFeedback={true}
                                                maxLength={500}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={5} className="ps-md-5 mt-5 mt-md-0">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fs-8">
                                            <span className="d-block">Upload Documents  <span style={{ color: 'red' }}>*</span></span>
                                            <small className="fw-semibold">(supported formats: jpeg, png, pdf, excel, doc)  | (Max Size : 50MB)</small>
                                        </Form.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <Form.Control
                                                type="file"
                                                name="document"
                                                onChange={handleChange}
                                                style={{ fontSize: '0.8rem', lineHeight: '2.4', color: '#999', minHeight: '33px' }}
                                                className={!!errors.document ? 'invalidinput' : ''}
                                                accept=".jpeg,.jpg,.png,.pdf,.xlx,.xlsx,.doc,docx"
                                                ref={resourceInputRef}
                                            />
                                        </div>
                                        {errors?.document ?
                                            <Form.Control.Feedback type="invalid" className="d-block">{errors.document}</Form.Control.Feedback> :
                                            <Form.Text>
                                                <div className={resourceMetadata.size ? "hinttxt" : ''} style={{ minHeight: '20px' }}>{resourceMetadata.size && <span><strong>Size:</strong> {resourceMetadata.size} MB</span>}</div>
                                            </Form.Text>
                                        }
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <div className="d-flex gap-3 justify-content-end">
                                    <Button variant="outline-secondary" type="button" className="px-4" disabled={waitForResponse} onClick={resetForm}>
                                        Reset
                                    </Button>
                                    <Button type="submit" className="save-btn px-5" disabled={waitForResponse}>
                                        Save
                                    </Button>
                                </div>
                            </Row>
                        </Form>
                    </div>
                </Col>
            </Row>
            {showAlert.show &&
                <AlertMassage
                    show={showAlert.show}
                    type={showAlert.type}
                    title={showAlert.title}
                    massage={showAlert.msg}
                    hideAlert={hideAlert} />
            }
        </div>
    );
}